export class DateTimeUtils {
    static parseLocalDate(dateStr: string, h = 0, m = 0, s = 0): Date {
        const parts = dateStr.split('-').map(part => parseInt(part, 10));
        return new Date(parts[0], parts[1] - 1, parts[2], h, m, s, 0);
    }
}